// src/pages/produccion/Reproceso.jsx
import { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../../services/api';

const RECETAS_GRANOLA = [
  'Granola Original', 'Granola Ligera', 'Granola Chocolate', 'Granola Vainilla', 'Granola Maple',
  'Cereal Arándano', 'Cereal Quinoa', 'Cereal Chocolate', 'Cereal Maple',
];
const TURNOS = ['Matutino', 'Nocturno'];

function loteMezclaVacio() {
  return { loteBuscado: '', buscando: false, loteInfo: null, cantidadUtilizada: '', cantidadDesviacion: '' };
}
function destinoVacio() {
  return {
    receta: RECETAS_GRANOLA[0], producto: '', lote_empaque: '', caducidad: '', observaciones: '',
    lotesMezcla: [loteMezclaVacio()],
  };
}

export default function Reproceso() {
  const [tab, setTab] = useState('captura');
  return (
    <div style={styles.paginaContenedor} className="contenedor-captura">
      <h1 style={styles.tituloPagina}>Reproceso</h1>
      <p style={styles.subtituloPagina}>
        Sustitución de ingrediente con material de Rechazo de Barras (responsabilidad de Empaque Granola).
      </p>
      <div style={styles.tabBar}>
        <button onClick={() => setTab('captura')} style={{ ...styles.tabBtn, ...(tab === 'captura' ? styles.tabBtnActivo : {}) }}>📝 Captura</button>
        <button onClick={() => setTab('historial')} style={{ ...styles.tabBtn, ...(tab === 'historial' ? styles.tabBtnActivo : {}) }}>📋 Historial</button>
      </div>
      {tab === 'captura' ? <TabCaptura /> : <TabHistorial />}
    </div>
  );
}

function TabCaptura() {
  const [fecha, setFecha] = useState(new Date().toISOString().slice(0, 10));
  const [turno, setTurno] = useState('Matutino');
  const [destinos, setDestinos] = useState([destinoVacio()]);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [productos, setProductos] = useState([]);

useEffect(() => {
  api.get('/api/catalogos/productos-terminados').then((res) => setProductos(res.data.data)).catch((err) => console.error(err));
}, []);

  function actualizarDestino(i, campo, valor) {
    setDestinos((prev) => prev.map((d, idx) => (idx === i ? { ...d, [campo]: valor } : d)));
  }
  function agregarDestino() { setDestinos((prev) => [...prev, destinoVacio()]); }
  function quitarDestino(i) { setDestinos((prev) => prev.filter((_, idx) => idx !== i)); }

  function actualizarLoteMezcla(destinoIdx, loteIdx, campo, valor) {
    setDestinos((prev) => prev.map((d, di) => {
      if (di !== destinoIdx) return d;
      const lotesMezcla = d.lotesMezcla.map((l, li) => (li === loteIdx ? { ...l, [campo]: valor } : l));
      return { ...d, lotesMezcla };
    }));
  }
  function agregarLoteMezcla(destinoIdx) {
    setDestinos((prev) => prev.map((d, di) => (di === destinoIdx ? { ...d, lotesMezcla: [...d.lotesMezcla, loteMezclaVacio()] } : d)));
  }
  function quitarLoteMezcla(destinoIdx, loteIdx) {
    setDestinos((prev) => prev.map((d, di) => (di === destinoIdx ? { ...d, lotesMezcla: d.lotesMezcla.filter((_, li) => li !== loteIdx) } : d)));
  }

  async function buscarLoteMezcla(destinoIdx, loteIdx) {
    const lote = destinos[destinoIdx].lotesMezcla[loteIdx].loteBuscado.trim();
    if (!lote) return;
    actualizarLoteMezcla(destinoIdx, loteIdx, 'buscando', true);
    try {
      const res = await api.get(`/api/produccion/reproceso/lote/${encodeURIComponent(lote)}`);
      actualizarLoteMezcla(destinoIdx, loteIdx, 'loteInfo', res.data.data ?? false);
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: 'No se pudo buscar el lote.' });
    } finally {
      actualizarLoteMezcla(destinoIdx, loteIdx, 'buscando', false);
    }
  }

  function formularioValido() {
    if (!fecha || !turno) return false;
    return destinos.every((d) => {
      if (!d.receta || !d.producto.trim() || !d.lote_empaque.trim()) return false;
      const lotesConDato = d.lotesMezcla.filter((l) => l.loteInfo && l.loteInfo !== false);
      return lotesConDato.length > 0;
    });
  }

  async function handleGuardarTodo() {
    try {
      setGuardando(true);
      setMensaje(null);
      for (const d of destinos) {
        const lotesMezcla = d.lotesMezcla
          .filter((l) => l.loteInfo && l.loteInfo !== false)
          .map((l) => ({
            lote_mezcla: l.loteBuscado.trim(),
            cantidad_utilizada: l.cantidadUtilizada || 0,
            cantidad_con_desviacion: l.cantidadDesviacion || 0,
          }));
        await api.post('/api/produccion/reproceso/destino', {
          fecha, turno, receta: d.receta, producto: d.producto.trim(), lote_empaque: d.lote_empaque.trim(),
          caducidad: d.caducidad || null, observaciones: d.observaciones || null, lotes_mezcla: lotesMezcla,
        });
      }
      setMensaje({ tipo: 'ok', texto: `✓ ${destinos.length} destino(s) guardado(s) correctamente.` });
      setDestinos([destinoVacio()]);
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || 'No se pudo guardar. Revisa cada destino.' });
    } finally {
      setGuardando(false);
    }
  }

  return (
    <div>
      <div style={styles.tarjeta}>
        <div className="fila2">
          <Campo label="Fecha">
            <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} style={styles.input} />
          </Campo>
          <Campo label="Turno">
            <select value={turno} onChange={(e) => setTurno(e.target.value)} style={styles.input}>
              {TURNOS.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </Campo>
        </div>
      </div>

      {destinos.map((d, di) => (
        <div key={di} style={{ ...styles.tarjeta, marginTop: '14px' }}>
          <div style={styles.destinoHeader}>
            <span style={styles.destinoTitulo}>Destino {di + 1}</span>
            {destinos.length > 1 && (
              <button onClick={() => quitarDestino(di)} style={styles.botonQuitarDestino}>✕ Quitar destino</button>
            )}
          </div>

          <div className="fila2">
            <Campo label="Receta">
              <select value={d.receta} onChange={(e) => actualizarDestino(di, 'receta', e.target.value)} style={styles.input}>
                {RECETAS_GRANOLA.map((r) => <option key={r} value={r}>{r}</option>)}
              </select>
            </Campo>
            <Campo label="Producto / Presentación">
              <select value={d.producto} onChange={(e) => actualizarDestino(di, 'producto', e.target.value)} style={styles.input}>
                <option value="">— Selecciona —</option>
                {productos.map((p) => <option key={p.netsuite_id} value={p.nombre}>{p.nombre}</option>)}
              </select>
            </Campo>
          </div>
          <div className="fila2">
            <Campo label="Lote de empaque">
              <input type="text" value={d.lote_empaque} onChange={(e) => actualizarDestino(di, 'lote_empaque', e.target.value)} placeholder="Ej. D0124526" style={styles.input} />
            </Campo>
            <Campo label="Caducidad">
              <input type="date" value={d.caducidad} onChange={(e) => actualizarDestino(di, 'caducidad', e.target.value)} style={styles.input} />
            </Campo>
          </div>

          <div style={styles.subseccion}>Lotes de mezcla a usar en este destino</div>
          {d.lotesMezcla.map((l, li) => (
            <div key={li} style={styles.bloqueLote}>
              <div style={{ display: 'flex', gap: '8px' }}>
                <input
                  type="text"
                  value={l.loteBuscado}
                  onChange={(e) => actualizarLoteMezcla(di, li, 'loteBuscado', e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && buscarLoteMezcla(di, li)}
                  placeholder="Lote de mezcla (Ej. D3403426)"
                  style={{ ...styles.input, flex: 1 }}
                />
                <button onClick={() => buscarLoteMezcla(di, li)} disabled={l.buscando} style={styles.botonBuscar}>
                  {l.buscando ? 'Buscando...' : 'Buscar'}
                </button>
                {d.lotesMezcla.length > 1 && (
                  <button onClick={() => quitarLoteMezcla(di, li)} style={styles.botonQuitarLote}>✕</button>
                )}
              </div>

              {l.loteInfo === false && (
                <div style={styles.avisoError}>Ese lote no existe en Rechazo de Barras.</div>
              )}

              {l.loteInfo && l.loteInfo !== false && (
                <div style={styles.infoLote}>
                  <div><strong>Receta:</strong> {l.loteInfo.receta} · <strong>Caducidad:</strong> {l.loteInfo.caducidad ? new Date(l.loteInfo.caducidad).toLocaleDateString('es-MX') : '—'}</div>
                  <div><strong>Apto para triturar:</strong> {parseFloat(l.loteInfo.apto_triturar).toFixed(2)} kg · <strong>Ya usado:</strong> {l.loteInfo.total_usado.toFixed(2)} kg</div>
                  <div style={styles.disponibleDestacado}><strong>Disponible ahora:</strong> {l.loteInfo.disponible.toFixed(2)} kg</div>

                  <div className="fila2" style={{ marginTop: '10px' }}>
                    <Campo label="Cantidad utilizada (kg)">
                      <input type="number" step="0.01" value={l.cantidadUtilizada} onChange={(e) => actualizarLoteMezcla(di, li, 'cantidadUtilizada', e.target.value)} style={styles.input} />
                    </Campo>
                    <Campo label="Cantidad con desviación (kg)">
                      <input type="number" step="0.01" value={l.cantidadDesviacion} onChange={(e) => actualizarLoteMezcla(di, li, 'cantidadDesviacion', e.target.value)} style={styles.input} />
                    </Campo>
                  </div>
                  {(parseFloat(l.cantidadUtilizada) || 0) > l.loteInfo.disponible && (
                    <div style={styles.avisoAdvertencia}>⚠ La cantidad utilizada supera lo disponible. Puedes guardar igual si es correcto, pero verifica.</div>
                  )}
                </div>
              )}
            </div>
          ))}
          <button onClick={() => agregarLoteMezcla(di)} style={styles.botonAgregarSecundario}>+ Agregar otro lote de mezcla</button>

          <Campo label="Observaciones (opcional)">
            <textarea value={d.observaciones} onChange={(e) => actualizarDestino(di, 'observaciones', e.target.value)} style={{ ...styles.input, height: '60px', resize: 'vertical' }} />
          </Campo>
        </div>
      ))}

      <button onClick={agregarDestino} style={styles.botonAgregarDestino}>+ Agregar otro destino</button>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      <button onClick={handleGuardarTodo} disabled={guardando || !formularioValido()} style={styles.botonGuardar}>
        {guardando ? 'Guardando...' : 'Guardar todo'}
      </button>
    </div>
  );
}

const MESES = [
  ['01', 'Enero'], ['02', 'Febrero'], ['03', 'Marzo'], ['04', 'Abril'], ['05', 'Mayo'], ['06', 'Junio'],
  ['07', 'Julio'], ['08', 'Agosto'], ['09', 'Septiembre'], ['10', 'Octubre'], ['11', 'Noviembre'], ['12', 'Diciembre'],
];
function ultimoDiaDelMes(anio, mes) {
  return new Date(anio, parseInt(mes), 0).getDate();
}

function TabHistorial() {
  const [registros, setRegistros] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [fDesde, setFDesde] = useState('');
  const [fHasta, setFHasta] = useState('');
  const [fMes, setFMes] = useState('');
  const [fAnio, setFAnio] = useState(new Date().getFullYear());
  const [expandidoId, setExpandidoId] = useState(null);

  async function cargar() {
    try {
      setCargando(true);
      const params = {};
      if (fDesde) params.desde = fDesde;
      if (fHasta) params.hasta = fHasta;
      const res = await api.get('/api/produccion/reproceso/destinos', { params });
      setRegistros(res.data.data);
      setError(null);
    } catch (err) {
      console.error(err);
      setError('No se pudo cargar el historial.');
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleMesChange(mes) {
    setFMes(mes);
    if (mes) {
      setFDesde(`${fAnio}-${mes}-01`);
      setFHasta(`${fAnio}-${mes}-${String(ultimoDiaDelMes(fAnio, mes)).padStart(2, '0')}`);
    }
  }
  function limpiarFiltros() {
    setFDesde(''); setFHasta(''); setFMes('');
  }

  function totalKg(destino) {
    return destino.lotes_consumidos.reduce((s, l) => s + parseFloat(l.cantidad_utilizada || 0), 0);
  }

  function exportarExcel() {
    const filas = [];
    registros.forEach((d) => {
      if (d.lotes_consumidos.length === 0) {
        filas.push({
          Fecha: new Date(d.fecha).toLocaleDateString('es-MX'), Turno: d.turno, Receta: d.receta, Producto: d.producto,
          'Lote de empaque': d.lote_empaque, Caducidad: d.caducidad ? new Date(d.caducidad).toLocaleDateString('es-MX') : '',
          'Lote de mezcla': '', 'Cant. Utilizada (kg)': '', 'Cant. con Desviación (kg)': '', Observaciones: d.observaciones || '',
        });
        return;
      }
      d.lotes_consumidos.forEach((l) => {
        filas.push({
          Fecha: new Date(d.fecha).toLocaleDateString('es-MX'), Turno: d.turno, Receta: d.receta, Producto: d.producto,
          'Lote de empaque': d.lote_empaque, Caducidad: d.caducidad ? new Date(d.caducidad).toLocaleDateString('es-MX') : '',
          'Lote de mezcla': l.lote_mezcla, 'Cant. Utilizada (kg)': l.cantidad_utilizada, 'Cant. con Desviación (kg)': l.cantidad_con_desviacion,
          Observaciones: d.observaciones || '',
        });
      });
    });
    const ws = XLSX.utils.json_to_sheet(filas);
    ws['!cols'] = [{ wch: 12 }, { wch: 10 }, { wch: 18 }, { wch: 12 }, { wch: 16 }, { wch: 12 }, { wch: 16 }, { wch: 16 }, { wch: 18 }, { wch: 40 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Reproceso');
    XLSX.writeFile(wb, `dasavena_reproceso_${new Date().toISOString().slice(0, 10)}.xlsx`);
  }

  return (
    <div>
      <div style={styles.headerFila}>
        <p style={styles.subtitulo}>Todos los destinos registrados, con sus lotes de mezcla consumidos.</p>
        <button onClick={exportarExcel} disabled={registros.length === 0} style={styles.botonExcel}>⬇ Descargar Excel</button>
      </div>

      <div style={styles.filtrosBar}>
        <FiltroFecha label="Desde" value={fDesde} onChange={(v) => { setFDesde(v); setFMes(''); }} />
        <FiltroFecha label="Hasta" value={fHasta} onChange={(v) => { setFHasta(v); setFMes(''); }} />
        <FiltroSel label="Mes" value={fMes} onChange={handleMesChange} options={[['', '—'], ...MESES]} />
        <div style={styles.filtroGrupo}>
          <label style={styles.filtroLabel}>Año</label>
          <input type="number" value={fAnio} onChange={(e) => setFAnio(e.target.value)} style={{ ...styles.filtroInput, width: '80px' }} />
        </div>
        <button onClick={cargar} style={styles.botonBuscar2}>Buscar</button>
        <button onClick={limpiarFiltros} style={styles.botonLimpiar}>Limpiar</button>
      </div>

      <div style={styles.resultadoInfo}>{registros.length} destinos</div>

      {cargando ? <div>Cargando...</div> : error ? <div style={{ color: '#B23A48' }}>{error}</div> : (
        <div style={styles.listaDestinos}>
          {registros.length === 0 && <p style={{ padding: 16, color: '#8A7690', fontSize: 12 }}>Sin registros para este filtro.</p>}
          {registros.map((d) => (
            <div key={d.id} style={styles.tarjetaDestino}>
              <div style={styles.filaDestinoHead} onClick={() => setExpandidoId(expandidoId === d.id ? null : d.id)}>
                <div>
                  <div style={styles.destinoNombre}>{d.receta} — {d.producto} <span style={styles.loteEmpaqueChico}>(lote {d.lote_empaque})</span></div>
                  <div style={styles.destinoMeta}>{new Date(d.fecha).toLocaleDateString('es-MX')} · {d.turno} · {totalKg(d).toFixed(2)} kg totales · {d.lotes_consumidos.length} lote(s) de mezcla</div>
                </div>
                <span style={styles.flechaExpandir}>{expandidoId === d.id ? '▲' : '▼'}</span>
              </div>
              {expandidoId === d.id && (
                <div style={styles.detalleDestino}>
                  {d.observaciones && <p style={styles.observacionDestino}>{d.observaciones}</p>}
                  <table style={styles.tabla}>
                    <thead>
                      <tr>
                        <th style={styles.th}>Lote de mezcla</th><th style={styles.th}>Receta origen</th>
                        <th style={styles.th}>Cant. Utilizada</th><th style={styles.th}>Cant. con Desviación</th>
                      </tr>
                    </thead>
                    <tbody>
                      {d.lotes_consumidos.map((l, idx) => (
                        <tr key={idx}>
                          <td style={styles.td}>{l.lote_mezcla}</td>
                          <td style={styles.td}>{l.receta_origen || '—'}</td>
                          <td style={{ ...styles.td, fontWeight: 700 }}>{l.cantidad_utilizada}</td>
                          <td style={styles.td}>{l.cantidad_con_desviacion}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Campo({ label, children }) {
  return <div style={{ marginBottom: '14px' }}><label style={styles.label}>{label}</label>{children}</div>;
}
function FiltroSel({ label, value, onChange, options }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}
function FiltroFecha({ label, value, onChange }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <input type="date" value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput} />
    </div>
  );
}

const styles = {
  paginaContenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42' },
  tituloPagina: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '2px' },
  subtituloPagina: { fontSize: '12px', color: '#8A7690', marginBottom: '16px' },
  tabBar: { display: 'flex', gap: '6px', borderBottom: '2px solid #E6DDD2', marginBottom: '20px' },
  tabBtn: { padding: '10px 20px', fontSize: '13px', fontWeight: 600, color: '#8A7690', background: 'none', border: 'none', borderBottom: '3px solid transparent', cursor: 'pointer', marginBottom: '-2px' },
  tabBtnActivo: { color: '#4A1E5C', borderBottom: '3px solid #4A1E5C' },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', maxWidth: '640px' },
  destinoHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' },
  destinoTitulo: { fontSize: '13px', fontWeight: 700, color: '#4A1E5C', textTransform: 'uppercase', letterSpacing: '0.4px' },
  botonQuitarDestino: { fontSize: '11px', color: '#B23A48', background: 'none', border: 'none', cursor: 'pointer' },
  label: { display: 'block', fontSize: '11px', color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '5px' },
  input: { width: '100%', padding: '8px 10px', fontSize: '13px', border: '1px solid #E6DDD2', borderRadius: '7px', fontFamily: 'Inter, sans-serif', boxSizing: 'border-box' },
  subseccion: { fontSize: '11px', fontWeight: 700, color: '#6E4F80', textTransform: 'uppercase', letterSpacing: '0.4px', margin: '14px 0 8px', paddingTop: '10px', borderTop: '1px solid #F0E9E0' },
  bloqueLote: { background: '#FAF6F0', border: '1px solid #F0E9E0', borderRadius: '9px', padding: '12px', marginBottom: '10px' },
  botonBuscar: { padding: '8px 14px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#4A1E5C', border: 'none', borderRadius: '7px', cursor: 'pointer', whiteSpace: 'nowrap' },
  botonQuitarLote: { width: '32px', border: 'none', background: '#F7E5E7', color: '#B23A48', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
  botonAgregarSecundario: { fontSize: '11.5px', color: '#6E4F80', background: '#EFE9F3', border: '1px dashed #A98BB8', borderRadius: '7px', padding: '7px 12px', cursor: 'pointer' },
  botonAgregarDestino: { display: 'block', width: '100%', maxWidth: '640px', marginTop: '10px', fontSize: '13px', fontWeight: 600, color: '#4A1E5C', background: '#fff', border: '1px dashed #4A1E5C', borderRadius: '9px', padding: '12px', cursor: 'pointer' },
  avisoError: { marginTop: '10px', fontSize: '12px', color: '#B23A48', background: '#F7E5E7', padding: '8px 12px', borderRadius: '7px' },
  avisoAdvertencia: { marginTop: '8px', fontSize: '11.5px', color: '#7a5417', background: '#F9F0DD', padding: '8px 12px', borderRadius: '7px' },
  infoLote: { marginTop: '10px', fontSize: '12px', color: '#3A2E42' },
  disponibleDestacado: { marginTop: '6px', fontSize: '13px', color: '#3E7C5A', background: '#E8F1EC', borderRadius: '6px', padding: '6px 10px', display: 'inline-block' },
  mensaje: { fontSize: '13px', margin: '14px 0', fontWeight: 600 },
  botonGuardar: { display: 'block', marginTop: '4px', width: '100%', maxWidth: '640px', padding: '14px', fontSize: '15px', fontWeight: 700, color: '#fff', background: '#4A1E5C', border: 'none', borderRadius: '9px', cursor: 'pointer' },
  headerFila: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', margin: 0 },
  botonExcel: { padding: '8px 16px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#3E7C5A', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  filtrosBar: { display: 'flex', alignItems: 'flex-end', gap: '12px', flexWrap: 'wrap', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '10px', padding: '14px 16px', marginBottom: '10px' },
  filtroGrupo: { display: 'flex', flexDirection: 'column', gap: '4px' },
  filtroLabel: { fontSize: '10px', color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.4px' },
  filtroInput: { padding: '6px 8px', fontSize: '12px', border: '1px solid #E6DDD2', borderRadius: '6px', fontFamily: 'Inter, sans-serif' },
  botonBuscar2: { padding: '7px 16px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#4A1E5C', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  botonLimpiar: { padding: '7px 14px', fontSize: '12px', color: '#8A7690', background: 'transparent', border: '1px solid #E6DDD2', borderRadius: '6px', cursor: 'pointer' },
  resultadoInfo: { fontSize: '12px', color: '#8A7690', marginBottom: '10px' },
  listaDestinos: { display: 'flex', flexDirection: 'column', gap: '10px' },
  tarjetaDestino: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '10px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', overflow: 'hidden' },
  filaDestinoHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', cursor: 'pointer' },
  destinoNombre: { fontSize: '13px', fontWeight: 700, color: '#2A1830' },
  loteEmpaqueChico: { fontWeight: 400, color: '#8A7690' },
  destinoMeta: { fontSize: '11px', color: '#8A7690', marginTop: '2px' },
  flechaExpandir: { fontSize: '10px', color: '#8A7690' },
  detalleDestino: { padding: '0 16px 16px', borderTop: '1px solid #F0E9E0' },
  observacionDestino: { fontSize: '12px', color: '#3A2E42', fontStyle: 'italic', margin: '12px 0' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '12.5px', marginTop: '10px' },
  th: { textAlign: 'left', padding: '6px 8px', borderBottom: '2px solid #E6DDD2', color: '#6E4F80', fontWeight: 600, fontSize: '10.5px', textTransform: 'uppercase' },
  td: { padding: '5px 8px', borderBottom: '1px solid #F0E9E0' },
};